import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className"];
import UIIcon from 'UIComponents/icon/UIIcon';
import { LORAX } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CertifiedBadge(_ref) {
  let {
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(UIIcon, Object.assign({}, rest, {
    className: className,
    color: LORAX,
    name: "hubspotCertification",
    size: "xs"
  }));
}